const baseAction = 'PENDO';

export const LAUNCH_PENDO_GUIDE = `${baseAction}/LAUNCH_PENDO_GUIDE`;
